import { render, staticRenderFns } from "./TenantsHeader.vue?vue&type=template&id=0ba080ec"
import script from "./TenantsHeader.vue.ts?vue&type=script&lang=ts&external"
export * from "./TenantsHeader.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports